module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image1",
      "src": "images/image001.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('p', {
    staticClass: "caption",
    attrs: {
      "id": "fm"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#fm"
    }
  }, [_c('b', [_vm._v("Europe at the beginning of World War I")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image1a",
      "src": "images/image001a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#fm"
    }
  }, [_c('b', [_vm._v("Europe during World War II (1942)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group_image"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/image002.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Post–World War II Germany")])])])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f744a2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustration.vue
// module id = 72
// module chunks = 0